<template>
  <div class="page-add-user">
    <p class="addText">修改密码</p>
    <el-form
      :label-position="labelPosition"
      label-width="180px"
      :model="formData"
      style="width: 400px"
      ref="formData"
    >
      <el-form-item label="新密码">
        <el-input
          v-model="formData.password"
          placeholder="请输入新密码"
          type="password"
          size="small"
        ></el-input>
      </el-form-item>
      <el-form-item label="确认新密码">
        <el-input
          v-model="formData.confirmPassword"
          placeholder="请再次输入新密码"
          type="password"
          size="small"
        ></el-input>
      </el-form-item>
    </el-form>
    <div class="el-form-item" style="width: 400px; text-align: center">
      <el-button type="primary" @click="submitForm('formData')" size="small"
        >确定</el-button
      >
    </div>
  </div>
</template>

<script>
import { Form as ElForm } from "element-ui";
export default {
  name: "systemConfig",
  components: {},
  data() {
    return {
      loading: false,
      labelPosition: "right",
      formData: {
        password: "",
        confirmPassword: "",
      },
      userInfo: {},
    };
  },
  created() {
    this.getUserInfo();
  },
  methods: {
    async getUserInfo() {
      let data = await this.$get("/personal/information");
      this.userInfo = data;
    },
    async submitForm(formName) {
      if (this.formData.password == "" || this.formData.confirmPassword == "") {
        this.$message({
          type: "warning",
          message: "请输入密码",
        });
        return;
      } else if (this.formData.password != this.formData.confirmPassword) {
        this.$message({
          type: "warning",
          message: "密码不一致，请重新输入",
        });
        return;
      }
      await this.$post("/user/addOrEdit", {
        ...this.userInfo,
        password: this.formData.password,
      });
      this.$message({
        type: "success",
        message: "修改成功",
      });
      this.$refs.formData.resetFields();
    },
  },
};
</script>

<style lang="scss" scoped>
.page-add-user {
  height: 100%;
  background: #fff;
  padding: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  .table-box {
    font-size: 14px;
  }
  .addText {
    width: 500px;
    text-align: center;
    font-size: 24px;
    font-weight: bold;
    margin-bottom: 20px;
  }
  .pages {
    background: #fff;
    margin-top: 10px;
    padding: 10px 10px;
    text-align: right;
    height: 55px;
    box-sizing: border-box;
  }
  .search-box {
    background: #fff;
    margin-bottom: 10px;
    padding: 10px 10px;
    border-radius: 4px;
    height: 55px;
    box-sizing: border-box;
    display: flex;
    justify-content: flex-end;
    .el-input {
      margin-left: 20px;
      width: 300px;
      margin-right: 10px;
    }
  }
}
</style>
